// src/main.ts
import './styles/main.css';
import { renderHome } from './ui-home';
import { renderGeoDiagnostic } from './ui-geo-diagnostic';
import { renderRoom } from './ui-room';
import { renderShareHandoff } from './ui-share';
import type { RoomLaunchConfig } from './room-state';

const app = document.getElementById('app')!;

function showHome(preserveInvite = false): void {
  const url = new URL(window.location.href);
  url.searchParams.delete('screen');
  if (!preserveInvite) {
    url.searchParams.delete('room');
    url.searchParams.delete('check');
  }
  history.replaceState(null, '', url);
  renderHome(app, showRoom, showRoom, showGeoDiagnostic);
}

function showGeoDiagnostic(): void {
  const url = new URL(window.location.href);
  url.searchParams.set('screen', 'geo-check');
  history.replaceState(null, '', url);
  renderGeoDiagnostic(app, () => showHome(true));
}

function showRoom(room: RoomLaunchConfig): void {
  const url = new URL(window.location.href);
  url.searchParams.delete('screen');
  url.searchParams.set('room', room.code);
  if (room.checkWord) url.searchParams.set('check', room.checkWord);
  else url.searchParams.delete('check');
  history.replaceState(null, '', url);
  renderRoom(app, room, showHome);
}

const initialParams = new URL(window.location.href).searchParams;
const initialScreen = initialParams.get('screen');
const initialRoom = initialParams.get('room')?.trim() ?? '';
if (initialScreen === 'geo-check') {
  renderGeoDiagnostic(app, () => showHome(true));
} else if (initialScreen === 'share' && initialRoom) {
  renderShareHandoff(
    app,
    initialRoom,
    initialParams.get('check')?.trim() ?? '',
    () => showHome(true),
    () => showHome(false),
  );
} else {
  showHome(true);
}
